(() => {
  'use strict';
  let modal, opener, previousOverflow;
  function getModal() {
    if (modal) return modal;
    modal = document.createElement('dialog');
    modal.className = 'k2-inspection-modal';
    modal.setAttribute('aria-labelledby', 'K2InspectionTitle');
    modal.innerHTML = '<button type="button" class="k2-inspection-close" aria-label="Close product details">×</button><div class="k2-inspection-content"></div>';
    document.body.append(modal);
    modal.querySelector('.k2-inspection-close').addEventListener('click', () => modal.close());
    modal.addEventListener('click', event => {
      if (event.target === modal) { const r = modal.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) modal.close(); }
      const thumb = event.target.closest('[data-inspection-thumb]'); if (!thumb) return;
      modal.querySelectorAll('[data-inspection-thumb]').forEach(button => button.setAttribute('aria-pressed', String(button === thumb)));
      modal.querySelectorAll('[data-inspection-media]').forEach(item => {
        item.hidden = item.dataset.inspectionMedia !== thumb.dataset.inspectionThumb;
        if (item.hidden) {
          item.querySelectorAll('video').forEach(video => video.pause());
          item.querySelectorAll('iframe').forEach(frame => { if (!frame.dataset.pausedSrc) { frame.dataset.pausedSrc = frame.src; frame.removeAttribute('src'); } });
        } else item.querySelectorAll('iframe[data-paused-src]').forEach(frame => { frame.src = frame.dataset.pausedSrc; delete frame.dataset.pausedSrc; });
      });
    });
    modal.addEventListener('close', () => {
      modal.querySelectorAll('video').forEach(video => video.pause());
      modal.querySelector('.k2-inspection-content').replaceChildren();
      document.documentElement.style.overflow = previousOverflow;
      if (opener?.isConnected) opener.focus({preventScroll: true});
    });
    return modal;
  }
  document.addEventListener('click', event => {
    const favoriteLink = event.target.closest('a[data-home-product]');
    if (favoriteLink && window.K2View) favoriteLink.href = window.K2View.homeURL(favoriteLink.dataset.homeProduct);
    const button = event.target.closest('[data-inspect-product]'); if (!button) return;
    const template = button.closest('[data-product-handle]')?.querySelector('.k2-inspection-template'); if (!template) return;
    event.preventDefault();
    const dialog = getModal();
    if (typeof dialog.showModal !== 'function') { window.alert('Please use an up-to-date browser to inspect this pattern.'); return; }
    const content = template.content.cloneNode(true);
    // Descriptions are informational here; do not expose embedded purchasing controls.
    content.querySelectorAll('.k2-inspection-description form, .k2-inspection-description button, .k2-inspection-description input, .k2-inspection-description select, .k2-inspection-description textarea, .k2-inspection-description script').forEach(node => node.remove());
    dialog.querySelector('.k2-inspection-content').replaceChildren(content);
    opener = button;
    previousOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    dialog.showModal();
    dialog.scrollTop = 0;
    dialog.querySelector('.k2-inspection-close').focus();
  });
  function refreshFavoriteLinks() {
    document.querySelectorAll('a[data-home-product]').forEach(link => { if (window.K2View) link.href = window.K2View.homeURL(link.dataset.homeProduct); });
  }
  window.addEventListener('pageshow', refreshFavoriteLinks);
  const productCard = (doc, handle) => [...doc.querySelectorAll('[data-product-handle]')].find(card => card.dataset.productHandle === handle);
  let locating = false;
  async function locateFavorite() {
    if (document.querySelector("[data-filter-catalog]")) return;
    if (locating) return;
    const url = new URL(location.href);
    const handle = url.searchParams.get('focus_product');
    const collection = document.querySelector('.k2-collection');
    if (!collection || !handle || !/^[a-z0-9][a-z0-9-]{0,254}$/.test(handle)) return;
    const current = productCard(document, handle);
    if (current) {
      requestAnimationFrame(() => requestAnimationFrame(() => {
        current.scrollIntoView({block: 'start', behavior: 'auto'});
        current.focus({preventScroll: true});
        current.classList.add('k2-product-found');
        setTimeout(() => current.classList.remove('k2-product-found'), 2400);
      }));
      url.searchParams.delete('focus_product'); url.hash = current.id;
      history.replaceState(history.state, '', url);
      return;
    }
    locating = true;
    const message = document.createElement('p');
    message.className = 'k2-locate-status'; message.setAttribute('role', 'status');
    message.textContent = 'Finding your saved pattern…'; collection.prepend(message);
    const visited = new Set([url.href]);
    let next = document.querySelector('.k2-pagination a[rel="next"]')?.href;
    try {
      while (next) {
        const destination = new URL(next, location.origin);
        if (destination.origin !== location.origin || visited.has(destination.href)) break;
        visited.add(destination.href);
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 12000);
        let response, html;
        try { response = await fetch(destination.href, {signal: controller.signal}); if (!response.ok) throw new Error('load'); html = await response.text(); }
        finally { clearTimeout(timeout); }
        const doc = new DOMParser().parseFromString(html, 'text/html');
        if (productCard(doc, handle)) {
          destination.searchParams.set('focus_product', handle); destination.hash = 'Pattern-' + handle;
          location.replace(destination.href); return;
        }
        next = doc.querySelector('.k2-pagination a[rel="next"]')?.getAttribute('href');
      }
      message.textContent = 'This saved pattern is not currently listed in the home collection.';
    } catch (_) {
      message.textContent = 'We could not locate this pattern. ';
      const retry = document.createElement('button'); retry.type = 'button'; retry.textContent = 'Try again';
      retry.addEventListener('click', () => { message.remove(); locateFavorite(); }); message.append(retry);
    } finally { locating = false; }
  }
  locateFavorite();
})();
